import { useApiContext, useGetFullInfo } from 'react-easyrocket';
import { useModalContext } from './useModalContext';
import { useEffect } from 'react';
import { isShowModalEvent } from 'src/config/helpers';
import { useLocation } from 'react-router';

export function useOpenEventModal() {
  const { isAuthenticated } = useApiContext();
  const { fullInfo } = useGetFullInfo();
  const { openModal } = useModalContext();
  const { pathname } = useLocation();

  useEffect(() => {
    const { shouldShowModal, day, fullDate } = isShowModalEvent();

    if (isAuthenticated && fullInfo?.level && shouldShowModal) {
      return openModal('EVENT_MODAL', { props: { day, fullDate } });
    }
  }, [fullInfo?.level, isAuthenticated, pathname]);
}
